import { CurrencySelect } from "../lib/currency";
import { Link } from "react-router-dom";
import { Mail, Instagram } from "lucide-react";
import { NEXUS_LOGO } from "../lib/api";

export const SUPPORT_EMAIL = "info@collabnexus.co.uk";
export const INSTAGRAM_URL = "https://www.instagram.com/collab.nexus.hq";
export const INSTAGRAM_HANDLE = "@collab.nexus.hq";

export default function Footer() {
  return (
    <footer className="px-6 lg:px-10 py-10 border-t border-white/5 text-sm text-zinc-500" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img src={NEXUS_LOGO} alt="" className="h-6 w-6 object-contain" />
            <span className="font-display font-bold text-white">NEXUS</span>
          </div>
          <p className="text-xs leading-relaxed max-w-xs">
            The two-sided marketplace where brands hire vetted creators and creators grow into paid collabs.
          </p>
          <p className="text-[11px] leading-relaxed max-w-xs mt-3 text-zinc-500" data-testid="footer-payments-note">
            Payments processed by <span className="text-zinc-300 font-semibold">Stripe</span>, an FCA-authorised payment institution. Brand funds are held until the brand approves the content, then released to the creator.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-400 mb-3">Platform</div>
          <ul className="space-y-2 text-xs">
            <li><Link to="/discover" className="hover:text-white">Discover creators</Link></li>
            <li><Link to="/campaigns" className="hover:text-white">Browse campaigns</Link></li>
            <li><Link to="/growth" className="hover:text-white">Growth AI</Link></li>
            <li><Link to="/how-it-works" className="hover:text-white" data-testid="footer-how-it-works-link">How it works</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-400 mb-3">Company</div>
          <ul className="space-y-2 text-xs">
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/case-studies" className="hover:text-white">Case studies</Link></li>
            <li><Link to="/hall-of-fame" className="hover:text-white">Hall of Fame</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact-link">Contact & support</Link></li>
            <li><Link to="/trust" className="hover:text-white" data-testid="footer-trust-link">Trust & safety</Link></li>
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy policy</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms of service</Link></li>
            <li><Link to="/data-deletion" className="hover:text-white" data-testid="footer-deletion-link">Data deletion</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-400 mb-3">Get in touch</div>
          <ul className="space-y-2 text-xs">
            <li>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-white inline-flex items-center gap-2" data-testid="footer-email-link">
                <Mail className="h-3.5 w-3.5" /> {SUPPORT_EMAIL}
              </a>
            </li>
            <li>
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="hover:text-white inline-flex items-center gap-2" data-testid="footer-instagram-link">
                <Instagram className="h-3.5 w-3.5" /> {INSTAGRAM_HANDLE}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-white/5 flex items-center justify-between flex-wrap gap-3 text-xs">
        <CurrencySelect className="mr-3" /><span data-testid="footer-company-details">© {new Date().getFullYear()} CollabNexus Ltd · Company No. 17438481 · Registered in England &amp; Wales · 71-75 Shelton Street, Covent Garden, London WC2H 9JQ</span>
        <div className="flex items-center gap-4 uppercase tracking-widest">
          <span>Escrow protected</span>
          <span>Verified creators</span>
        </div>
      </div>
    </footer>
  );
}
